import { render, staticRenderFns } from "./WizardCheckbox.vue?vue&type=template&id=bc17837c"
import script from "./WizardCheckbox.vue?vue&type=script&lang=ts"
export * from "./WizardCheckbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports